import React from "react";
import PropTypes from "prop-types";

/**
 * Client logo — wordmark is always white; brand mark uses fixed brand gradients.
 */
const ClientLogoSvg = ({ width = 100, className, style, onClick }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 615 135"
    width={width}
    className={className}
    style={{
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2,
      ...style,
    }}
    onClick={onClick}
  >
    <path
      fill="#ffffff"
      d="M488.606 329.899c-5.292 0-10.585 2.876-13.116 8.514h26.002c-2.301-5.638-7.594-8.514-12.886-8.514m.805 31.984c5.281 0 10.562-2.422 13.242-7.1.575-1.002 1.739-1.512 2.882-1.352l8.598 1.198c1.806.251 2.924 2.126 2.262 3.824-4.588 11.745-15.565 17.352-26.639 17.352-15.071 0-30.488-10.355-30.488-29.683 0-19.214 14.496-29.453 28.993-29.453 14.266 0 28.648 9.894 29.223 30.948 0 .953-.773 1.726-1.726 1.726h-41.533c1.38 8.514 8.398 12.54 15.186 12.54M566.491 346.006c0-8.858-6.673-16.107-14.727-16.107-8.168 0-14.841 7.249-14.841 16.107s6.673 16.108 14.841 16.108c8.054 0 14.727-7.249 14.727-16.108m14.726-24.909v78.91a2.834 2.834 0 0 1-2.834 2.835h-9.057a2.835 2.835 0 0 1-2.835-2.835v-32.026c-4.602 5.063-11.275 7.709-17.948 7.709-13.001 0-26.348-9.78-26.348-29.684 0-19.903 13.347-29.683 26.348-29.683 6.903 0 13.691 2.762 18.408 8.284l6.443-6.673c1.007-1.007 2.29-1.464 3.698-1.368 2.342.158 4.125 2.184 4.125 4.531M644.72 319.848v51.157c0 2.557-2.093 4.763-4.648 4.682-1.202-.037-2.289-.497-3.06-1.378l-6.328-6.443c-4.602 5.178-11.275 7.824-17.718 7.824-11.39 0-22.55-7.939-22.55-24.506l-.316-31.307a2.834 2.834 0 0 1 2.834-2.863h9.029a2.834 2.834 0 0 1 2.834 2.834v28.46c0 10.124 6.213 14.956 12.426 14.956 6.328 0 12.771-5.062 12.771-14.842v-28.574a2.834 2.834 0 0 1 2.834-2.834h9.058a2.834 2.834 0 0 1 2.834 2.834M654.611 372.395v-52.547a2.834 2.834 0 0 1 2.835-2.834h9.057a2.835 2.835 0 0 1 2.835 2.834v52.547a2.836 2.836 0 0 1-2.835 2.835h-9.057a2.835 2.835 0 0 1-2.835-2.835m7.478-62.399c-2.876 0-5.637-1.726-6.903-4.602-1.611-3.797.23-8.169 4.027-9.78.92-.345 1.956-.575 2.876-.575 2.991 0 5.752 1.726 6.903 4.602 1.611 3.797-.23 8.283-4.027 9.779-.92.345-1.956.576-2.876.576M723.64 346.006c0-8.858-6.673-16.107-14.727-16.107-8.168 0-14.841 7.249-14.841 16.107v.116c0 8.859 6.673 15.992 14.841 15.992 8.054 0 14.727-7.249 14.727-16.108m-11.62-29.683c13 0 26.346 9.78 26.346 29.683 0 19.904-13.346 29.684-26.346 29.684-6.673 0-13.231-2.646-17.948-7.709v32.026a2.835 2.835 0 0 1-2.835 2.835h-9.057a2.835 2.835 0 0 1-2.835-2.835v-78.91c0-2.347 1.784-4.373 4.125-4.531 1.408-.096 2.691.361 3.699 1.368l6.442 6.673c4.718-5.522 11.506-8.284 18.409-8.284M790.02 346.006c0-8.858-6.673-16.107-14.726-16.107-8.169 0-14.842 7.249-14.842 16.107v.116c0 8.859 6.673 15.992 14.842 15.992 8.053 0 14.726-7.249 14.726-16.108m-11.62-29.683c13.001 0 26.347 9.78 26.347 29.683 0 19.904-13.346 29.684-26.347 29.684-6.673 0-13.231-2.646-17.948-7.709v32.026a2.835 2.835 0 0 1-2.835 2.835h-9.057a2.835 2.835 0 0 1-2.835-2.835v-78.909c0-2.347 1.784-4.374 4.125-4.532 1.408-.096 2.691.361 3.699 1.368l6.443 6.673c4.717-5.522 11.505-8.284 18.408-8.284M838.797 329.899c-5.292 0-10.584 2.876-13.115 8.514h26.001c-2.301-5.638-7.593-8.514-12.886-8.514m.806 31.984c5.28 0 10.562-2.422 13.242-7.1.575-1.002 1.739-1.512 2.882-1.352l8.598 1.198c1.805.251 2.925 2.126 2.262 3.824-4.589 11.745-15.566 17.352-26.639 17.352-15.071 0-30.488-10.355-30.488-29.683 0-19.214 14.496-29.453 28.993-29.453 14.266 0 28.647 9.894 29.222 30.948 0 .953-.772 1.726-1.725 1.726h-41.534c1.381 8.514 8.399 12.54 15.187 12.54M916.568 346.352c0-8.975-6.673-16.107-14.727-16.107-8.169 0-14.841 7.132-14.841 16.107 0 8.858 6.672 15.992 14.841 15.992 8.054 0 14.727-7.134 14.727-15.992m14.726-50.78v50.119c0 16.561-13.553 30.467-30.11 30.107-16.033-.349-28.911-13.442-28.911-29.446 0-19.904 13.346-29.683 26.347-29.683 6.673 0 13.23 2.531 17.948 7.593v-28.69a2.834 2.834 0 0 1 2.834-2.834h9.057a2.834 2.834 0 0 1 2.835 2.834"
      transform="translate(-319.5 -275)"
    />
    <path
      d="m370.874 312.555 14.048 21.679c3.179 4.913 3.236 11.292.146 16.265l-17.785 27.481c-6.991 11.537-13.536 12.615-24.505 12.615h-18.259c-3.589.219-3.071-2.187-2.024-3.838z"
      style={{ fill: "url(#clientLogoGradientA)" }}
      transform="translate(-319.5 -275)"
    />
    <path
      d="m370.874 372.431 14.035-21.687a15.18 15.18 0 0 0 .159-16.257l-17.785-27.481c-6.991-11.537-13.536-12.614-24.505-12.614h-18.259c-3.589-.22-3.071 2.186-2.024 3.837z"
      style={{ fill: "#4fbb7c", fillRule: "nonzero" }}
      transform="translate(-319.5 -275)"
    />
    <path
      d="m426.113 313.13 14.18 21.475c3.179 4.913 3.236 11.292.146 16.265l-28.21 42.679c-5.326 8.57-14.537 13.756-24.432 13.756h-18.259c-1.918 0-3.071-2.186-2.024-3.837z"
      style={{ fill: "url(#clientLogoGradientB)" }}
      transform="translate(-319.5 -275)"
    />
    <path
      d="m426.098 372.522 14.22-21.47c3.243-5.039 3.149-11.369.059-16.342l-28.21-42.679c-5.325-8.57-14.537-13.757-24.432-13.757h-18.259c-1.918 0-3.071 2.187-2.024 3.838z"
      style={{ fill: "#4fbb7c", fillRule: "nonzero" }}
      transform="translate(-319.5 -275)"
    />
    <defs>
      <linearGradient
        id="clientLogoGradientA"
        x1="0"
        x2="1"
        y1="0"
        y2="0"
        gradientTransform="rotate(137.334 121.32 243.493)scale(88.24806)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" style={{ stopColor: "#06795f", stopOpacity: 1 }} />
        <stop offset=".14" style={{ stopColor: "#06795f", stopOpacity: 1 }} />
        <stop offset=".3" style={{ stopColor: "#329c71", stopOpacity: 1 }} />
        <stop offset=".48" style={{ stopColor: "#67bf82", stopOpacity: 1 }} />
        <stop offset="1" style={{ stopColor: "#67bf82", stopOpacity: 1 }} />
      </linearGradient>
      <linearGradient
        id="clientLogoGradientB"
        x1="0"
        x2="1"
        y1="0"
        y2="0"
        gradientTransform="rotate(128.355 134.344 273.188)scale(114.6056)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" style={{ stopColor: "#06795f", stopOpacity: 1 }} />
        <stop offset=".14" style={{ stopColor: "#06795f", stopOpacity: 1 }} />
        <stop offset=".3" style={{ stopColor: "#329c71", stopOpacity: 1 }} />
        <stop offset=".48" style={{ stopColor: "#67bf82", stopOpacity: 1 }} />
        <stop offset="1" style={{ stopColor: "#67bf82", stopOpacity: 1 }} />
      </linearGradient>
    </defs>
  </svg>
);

ClientLogoSvg.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func,
};

export default ClientLogoSvg;
